/** What a change did, as the timeline's series table and the outcome filter name it. */
export enum ActivityOutcomeKind {
    TASKS_COMPLETED = "tasksCompleted",
    TASKS_ASSIGNED_TO_VIEWER = "tasksAssignedToViewer",
    TRANSACTIONS_CATEGORIZED = "transactionsCategorized",
    BLOCKING_TASKS_ADDED = "blockingTasksAdded",
    JOURNAL_ENTRIES_POSTED = "journalEntriesPosted",
    TRANSACTIONS_RECATEGORIZED = "transactionsRecategorized",
    JOURNAL_ENTRIES_UPDATED = "journalEntriesUpdated",
    JOURNAL_ENTRIES_REVERSED = "journalEntriesReversed",
    ACCOUNTS_RECONCILED = "accountsReconciled",
    TRANSFERS_MATCHED = "transfersMatched",
    TRANSACTIONS_SPLIT = "transactionsSplit",
    ACCOUNTS_MERGED = "accountsMerged",
    ACCOUNTS_DELETED = "accountsDeleted",
    TRANSACTIONS_UPDATED = "transactionsUpdated",
    TRANSFERS_UNMATCHED = "transfersUnmatched",
    SPLITS_REMOVED = "splitsRemoved",
    ACCOUNTS_UPDATED = "accountsUpdated",
    TASKS_CREATED = "tasksCreated",
    TASKS_DELETED = "tasksDeleted",
    MEMBERS_ADDED = "membersAdded",
    MEMBERS_REMOVED = "membersRemoved",
    INVITES_SENT = "invitesSent",
}

/** The order product ranks outcomes in, most important first. */
export const ACTIVITY_OUTCOME_PRIORITY: readonly ActivityOutcomeKind[] = [
    ActivityOutcomeKind.TASKS_COMPLETED,
    ActivityOutcomeKind.TASKS_ASSIGNED_TO_VIEWER,
    ActivityOutcomeKind.TRANSACTIONS_CATEGORIZED,
    ActivityOutcomeKind.BLOCKING_TASKS_ADDED,
    ActivityOutcomeKind.JOURNAL_ENTRIES_POSTED,
    ActivityOutcomeKind.TRANSACTIONS_RECATEGORIZED,
    ActivityOutcomeKind.JOURNAL_ENTRIES_UPDATED,
    ActivityOutcomeKind.JOURNAL_ENTRIES_REVERSED,
    ActivityOutcomeKind.ACCOUNTS_RECONCILED,
    ActivityOutcomeKind.TRANSFERS_MATCHED,
    ActivityOutcomeKind.TRANSACTIONS_SPLIT,
    ActivityOutcomeKind.ACCOUNTS_MERGED,
    ActivityOutcomeKind.ACCOUNTS_DELETED,
    ActivityOutcomeKind.TRANSACTIONS_UPDATED,
    ActivityOutcomeKind.TRANSFERS_UNMATCHED,
    ActivityOutcomeKind.SPLITS_REMOVED,
    ActivityOutcomeKind.ACCOUNTS_UPDATED,
    ActivityOutcomeKind.TASKS_CREATED,
    ActivityOutcomeKind.TASKS_DELETED,
    ActivityOutcomeKind.MEMBERS_ADDED,
    ActivityOutcomeKind.MEMBERS_REMOVED,
    ActivityOutcomeKind.INVITES_SENT,
];
